import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import GatsbyImage from "gatsby-image/withIEPolyfill"
import styled from "@emotion/styled"
import { Link } from "gatsby"
import { color, ColorProps } from "styled-system"

const query = graphql`
  fragment StoryThumb on File {
    childImageSharp {
      fixed(
        fit: COVER
        width: 500
        height: 500
        cropFocus: NORTH
        quality: 80
      ) {
        ...GatsbyImageSharpFixed_withWebp
      }
    }
  }

  query {
    rahma: file(relativePath: { eq: "rahma.jpg" }) {
      ...StoryThumb
    }
    ahmad: file(relativePath: { eq: "ahmad.jpg" }) {
      ...StoryThumb
    }
    khairul: file(relativePath: { eq: "khairul.jpg" }) {
      ...StoryThumb
    }
    odin: file(relativePath: { eq: "odin.jpg" }) {
      ...StoryThumb
    }
    amir: file(relativePath: { eq: "amir.jpg" }) {
      ...StoryThumb
    }
  }
`

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  height: 100vh;
  margin: 0 auto;

  @media screen and (min-width: 60em) {
    grid-template-columns: repeat(3, 1fr);
  }
`

const StoryLink = styled(Link)<Omit<ColorProps, "color">>`
  position: relative;
  overflow: hidden;
  width: 100%;

  background-color: ${({ theme }) => theme.colors.grey900};

  text-decoration: none;

  ${color}
`

const Img = styled(GatsbyImage)`
  display: block !important;
  width: 100% !important;
  height: 100% !important;

  opacity: 0.6;
  transition: opacity 700ms linear;

  ${StoryLink}:hover & {
    opacity: 1;
  }
`

const LinkTitle = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100% !important;
  height: 100% !important;

  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  font-family: ${({ theme }) => theme.fonts.effect};
  font-size: ${({ theme }) => theme.fontSizes["2xl"]};
  text-transform: uppercase;
  text-align: center;
  letter-spacing: 0.025em;

  color: ${({ theme }) => theme.colors.wheat};

  opacity: 1;
  transition: all 1000ms cubic-bezier(0.645, 0.045, 0.355, 1);

  ${StoryLink}:hover & {
    opacity: 0;
    transform: translateY(-1.2rem);
  }

  @media screen and (min-width: 35em) {
    font-size: ${({ theme }) => theme.fontSizes["4xl"]};
  }

  @media screen and (min-width: 70em) {
    font-size: ${({ theme }) => theme.fontSizes["5xl"]};
  }
`

const StoryPicker = () => {
  const data = useStaticQuery(query)
  return (
    <Grid>
      <StoryLink to="/story/odin">
        <Img
          fixed={data.odin.childImageSharp.fixed}
          loading="eager"
          objectPosition="center top"
        />
        <LinkTitle>Odin's story</LinkTitle>
      </StoryLink>
      <StoryLink to="/story/rahma">
        <Img
          fixed={data.rahma.childImageSharp.fixed}
          loading="eager"
          objectPosition="center top"
        />
        <LinkTitle>Rahma's story</LinkTitle>
      </StoryLink>
      <StoryLink to="/story/ahmad">
        <Img fixed={data.ahmad.childImageSharp.fixed} loading="eager" />
        <LinkTitle>Ahmad's story</LinkTitle>
      </StoryLink>
      <StoryLink to="/story/khairul">
        <Img
          fixed={data.khairul.childImageSharp.fixed}
          loading="eager"
          objectPosition="center top"
        />
        <LinkTitle>Khairul's story</LinkTitle>
      </StoryLink>
      <StoryLink to="/story/amir">
        <Img
          fixed={data.amir.childImageSharp.fixed}
          loading="eager"
          objectPosition="center top"
        />
        <LinkTitle>Amir's story</LinkTitle>
      </StoryLink>
      <StoryLink bg="viridian" to="/findings#reports">
        <LinkTitle>Download reports</LinkTitle>
      </StoryLink>
    </Grid>
  )
}

export default StoryPicker
